import {useSelectDay} from "../useAppPullState";
import NewList from "./NewList";
import {mapCourseItem} from "./selectors/mapCourseItem";
import {Tooltip} from "antd";
import React from "react";

import {useCoursesList} from "./useCoursesList";
import {useDesktop} from "./useDesktop";
import {useChangeWeekendComponent} from "./hooks/useChangeWeekendComponent";

export const CourseRow = ({
                              index, // Index of row
                              style,
                          }) => {
    const {dateValue, bookedSlots, filteredGolfCourses} = useCoursesList();
    const item = filteredGolfCourses[index];
    const selectDay = useSelectDay();
    const isDesktop = useDesktop();
    // console.log("[[CourseRow]]", item?.data)
    return (
        <NewList
            style={style}
            courseName={{children: item?.data?.courseName}}
            item={mapCourseItem(item, bookedSlots, dateValue, selectDay, isDesktop)}
            tooltip={
                <Tooltip title={item?.data?.courseName}>
                        <span style={{fontSize: isDesktop ? "1rem" :"2.5vw", fontWeight: "bold", overflow: "inherit", paddingLeft: 2}}>
                          {item?.data?.courseName}
                        </span>
                </Tooltip>
            }
        />
    )
}
